module.exports = __webpack_public_path__ + "img/thumbnail.506bf9e6.jpg";